export interface BglLoadingProps {
  className : string
}

export const BglLoading = (props : BglLoadingProps) => {
  return (
    <div className={props.className}>
      <img style={{height: '60px'}} src={`https://static.bidgely.com/images/loading.gif`} alt="Loading"/>
    </div>
  )
}